import React from "react";

import { Container, Row, Col } from "react-bootstrap";

import POSTURALCORRECTIVE from "../images/posturalCorrectiveExercises.png";
import WEIGHTLOSS from "../images/weightLoss.png";
import INDIVIDUALTRAINING from "../images/individualTraining.png";
import TEAMTRAINING from "../images/teamTraining.png";
import BODYRECOMPOSITION from "../images/bodyRecomposition.png";
import { PALETTE } from "../../common/ThemeConstants";
import FeatureCard from "./FeatureCard";

export default function HomeFeaturesTop() {
  return (
    <Container className="align-self-center text-center">
      <Row className="pb-3">
        <Col>
          <h1 className="text-center my-3" style={{ color: PALETTE.DARK }}>
            1. Definisci{" "}
            <span style={{ fontWeight: "bold" }}>i tuoi obiettivi</span>
          </h1>
          <p className="home-subtitle">
            Crea il tuo percorso di allenamento personale in base alle tue
            finalità e obiettivi
          </p>
        </Col>
      </Row>
      <Row className="m-auto" style={{ width: "100%" }}>
        <Col>
          <Row className="m-auto" style={{ maxWidth: "fit-content" }}>
            <Col className="m-auto pt-2 pb-2">
              <FeatureCard
                cover={BODYRECOMPOSITION}
                text={"Ricomposizione corporea"}
                textColor={PALETTE.DARK}
              />
            </Col>
            <Col className="m-auto pt-2 pb-2">
              <FeatureCard
                cover={WEIGHTLOSS}
                text={"Dimagrimento"}
                textColor={PALETTE.DARK}
              />
            </Col>
            <Col className="m-auto pt-2 pb-2">
              <FeatureCard
                cover={POSTURALCORRECTIVE}
                text={"Esercizio correttivo (Posturale)"}
                textColor={PALETTE.DARK}
              />
            </Col>
          </Row>
          <Row className="m-auto" style={{ maxWidth: "fit-content" }}>
            <Col className="m-auto pt-2 pb-2">
              <FeatureCard
                cover={TEAMTRAINING}
                text={"Preparazione atletica di squadra"}
                textColor={PALETTE.DARK}
              />
            </Col>
            <Col className="m-auto pt-2 pb-2">
              <FeatureCard
                cover={INDIVIDUALTRAINING}
                text={"Preparazione atletica individuale"}
                textColor={PALETTE.DARK}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
